module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="quizDialogWrapper" class="xDialogWrapper">\n    ';
 if(typeof(title)!=="undefined"){
        
__p+='<p id="quizDialogTitle" class="xDialogContent">'+
((__t=(title))==null?'':__t)+
'</p>\n    ';
 }
    if(typeof(content)!=="undefined"){
        
__p+='<p id="quizDialogContent" class="xDialogContent">'+
((__t=(content))==null?'':__t)+
'</p>\n    ';
 }
    
__p+='<div id="quizDialogFooter" class="xDialogFooter">\n        ';
 if(typeof(ok)!=="undefined"){
            
__p+='<a href="#" class="xButton xAction xActionCloseOverlay"><span>'+
((__t=( NGX.lang.get('buttons.ok') ))==null?'':__t)+
'</span></a>\n        ';
 }
        if(typeof(carryon)!=="undefined"){
            
__p+='<a href="#" class="xButton xAction xActionCloseOverlay"><span>'+
((__t=( NGX.lang.get('buttons.continue') ))==null?'':__t)+
'</span></a>\n        ';
 }
        if(typeof(submit)!=="undefined"){
            
__p+='<a href="#" class="xButton xCTA xSubmit"><span>'+
((__t=( NGX.lang.get('buttons.enter') ))==null?'':__t)+
'</span></a>\n        ';
 }
        if(typeof(skip)!=="undefined"){
            
__p+='<a href="#" class="xButton skipButton"><span>'+
((__t=( NGX.lang.get('buttons.skip') ))==null?'':__t)+
'</span></a>\n        ';
 }
        if(typeof(restart)!=="undefined"){
            
__p+='<a href="#" class="xButton xReset"><span>'+
((__t=( NGX.lang.get('buttons.restart') ))==null?'':__t)+
'</span></a>\n        ';
 } 
__p+='\n    </div>\n</div>\n';
}
return __p;
};
